import { render, staticRenderFns } from "./StudentLeave.vue?vue&type=template&id=c0b46b96&"
import script from "./StudentLeave.vue?vue&type=script&lang=js&"
export * from "./StudentLeave.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeave.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports